import { render } from "./RolePower.vue?vue&type=template&id=5b4531ba&scoped=true"
import script from "./RolePower.vue?vue&type=script&lang=js"
export * from "./RolePower.vue?vue&type=script&lang=js"

import "./RolePower.vue?vue&type=style&index=0&id=5b4531ba&lang=scss&scoped=true"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4531ba"]])

export default __exports__